var map = {
	"./404.webp": "d619",
	"./apps (1).png": "37e4",
	"./apps.png": "d1e8",
	"./archive (1).png": "30a6",
	"./archive.png": "1c41",
	"./bb_logo.ico": "df84",
	"./bb_logo.png": "b8a2",
	"./blood-test.png": "d951",
	"./box (1).png": "759c",
	"./box.png": "5636",
	"./bread-slice (1).png": "cf66",
	"./bread-slice.png": "cd9f",
	"./cube (1).png": "8d72",
	"./cube.png": "b8b2",
	"./dashboard.1fb16ffd58386e26d960.css": "b4cc",
	"./database (1).png": "45bc",
	"./database.png": "a27e",
	"./grid (1).png": "35c0",
	"./grid.png": "f8b1",
	"./inbox (1).png": "1a87",
	"./inbox.png": "0af2",
	"./layers (1).png": "b9fc",
	"./layers.png": "7f47",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./shop (1).png": "f53e",
	"./shop.png": "0173",
	"./style.css": "7d05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";